<script setup lang="ts">
import { useSwiper } from 'swiper/vue'

const swiper = useSwiper()
const isPrevDisabled = computed(() => !swiper.value.params.loop && swiper.value.isBeginning)
const isNextDisabled = computed(() => !swiper.value.params.loop && swiper.value.isEnd)
</script>

<template>
  <div>
    <Button
      variant="solid"
      :class="{
        'text-neutral-600 pointer-events-none cursor-default bg-neutral-50': isPrevDisabled
      }"
      :disabled="isPrevDisabled"
      :aria-label="$t('swiper.previous')"
      :icon="{
        name: 'custom:arrow-left',
        style: isPrevDisabled ? 'color: black' : 'color: white'
      }"
      @click="swiper.slidePrev()"
    />
    <Button
      variant="solid"
      :class="{
        'text-neutral-600 pointer-events-none cursor-default bg-neutral-50': isNextDisabled
      }"
      :disabled="isNextDisabled"
      :aria-label="$t('swiper.next')"
      class="ml-4"
      :icon="{ name: 'custom:arrow-right', style: swiper.isEnd ? 'color: black' : 'color: white' }"
      @click="swiper.slideNext()"
    />
  </div>
</template>
